import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { studyHabitsContent } from '../content';

const habitDetail = (habit: (typeof studyHabitsContent.habits)[number]): string => {
  const blockLines = habit.blocks.map((block) => {
    if (block.callout) {
      return `${block.callout.label}: ${block.callout.text}`;
    }

    return [block.heading, block.text, ...(block.bullets ?? [])].filter(Boolean).join(' ');
  });

  return [`${habit.number}. ${habit.title} — ${habit.subtitle ?? ''}`, habit.intro, ...blockLines]
    .filter(Boolean)
    .join('\n');
};

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Overview',
    description:
      'Introduction to studying smarter (not harder) — building simple systems that front-load learning, make review efficient, and protect focus.',
    detail: studyHabitsContent.header.description.join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: studyHabitsContent.tools.title,
    description: 'Backrs tools and competencies to support building better study habits.',
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'The Five Study Habits',
    description:
      'Five habits for studying smarter: be organized, let your notes do the heavy lifting (QEC method), reject rote review (active recall), write papers over three days, and study like Darwin (constant improvement).',
    detail: studyHabitsContent.habits.map(habitDetail).join('\n\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: studyHabitsContent.workday.title,
    description:
      'Six rules for a high-performance student workday: isolation, 50/10 cycles, working in school, avoiding distractions, keeping energy high, and staying off the internet.',
    detail: [
      studyHabitsContent.workday.intro,
      ...studyHabitsContent.workday.rules.map(
        (rule) => `${rule.number}. ${rule.title}: ${rule.body}`,
      ),
    ].join('\n'),
  });
};
